import Index from '@/modules/Bonventa/index.vue'
import Location from '@/modules/Bonventa/components/Location.vue'
import LocationProfile from '@/modules/Bonventa/components/Profile.vue'

export default [{
  path: '/bonventa',
  name: 'bonventa',
  component: Index,
  title: 'Bonventa',
  children: [{
    path: 'location',
    name: 'bonventa-location-list',
    component: Location,
  },
  {
    path: ':id/profile',
    name: 'bonventa-location-profile',
    component: LocationProfile,
  },
  ],
}]
